// extracted by mini-css-extract-plugin
export default {"fr-view":"Chapters_fr-view__WGdea","chapter":"Chapters_chapter__45mzb"};